export default __webpack_public_path__ + "static/media/expl-nn_02_DE.3ee26177.png";